import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { PrimeIcons } from "primereact/api";

import { GenericBackToBtnProps } from "../../interfaces";

export const GenericBackToBtn = (props: GenericBackToBtnProps) => {
  return (
    <Link to={props.link}>
      <Button
        className="button-back-to"
        icon={PrimeIcons.ARROW_LEFT}
        label={props.label}
        text
      />
    </Link>
  );
};
